/**
 * Fabric & Leather Availability Color Switcher
 * Caches correct Liquid-calculated totals on load, then restores them after color changes.
 * Prevents competing theme JS from overwriting correct values with wrong individual variant data.
 */
document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".color-fabric-total, .color-leather-total").forEach(div => {
    const span = div.querySelector(".product__inventory-inner");
    if (span) div.dataset.original = span.textContent.trim();
  });

  function restoreAndShow(productCard, color) {
    // Handle both fabric and leather
    ['fabric', 'leather'].forEach(type => {
      const container = productCard.querySelector(`[id^="total-${type}-availability-"]`);
      if (!container) return;

      container.querySelectorAll(`.color-${type}-total`).forEach(div => {
        const isMatch = div.dataset.color === color;
        div.style.display = isMatch ? "block" : "none";
        if (isMatch && div.dataset.original) {
          const span = div.querySelector(".product__inventory-inner");
          if (span) span.textContent = div.dataset.original;
        }
      });
    });
  }

  function hideEmptyColorSwatches(productCard) {
    const swatchesContainer = productCard.querySelector('.js-color-swatches');
    if (!swatchesContainer) return;

    // Get all available colors from pre-calculated divs
    const availableColors = new Set();
    ['fabric', 'leather'].forEach(type => {
      const container = productCard.querySelector(`[id^="total-${type}-availability-"]`);
      if (container) {
        container.querySelectorAll(`.color-${type}-total`).forEach(div => {
          if (div.dataset.original && div.dataset.original.trim() !== '') {
            availableColors.add(div.dataset.color);
          }
        });
      }
    });

    // Hide swatches for colors with no inventory
    swatchesContainer.querySelectorAll('input[type="radio"][name*="Colore"]').forEach(input => {
      const colorValue = input.value;
      const label = swatchesContainer.querySelector(`label[for="${input.id}"]`);
      
      if (!availableColors.has(colorValue)) {
        input.style.display = 'none';
        if (label) label.style.display = 'none';
      } else {
        input.style.display = '';
        if (label) label.style.display = '';
      }
    });
  }

  // Process all product cards
  document.querySelectorAll('.card-information__group').forEach(productCard => {
    // Hide empty color swatches
    hideEmptyColorSwatches(productCard);

    // Add color change listeners
    const swatchesContainer = productCard.querySelector('.js-color-swatches');
    if (swatchesContainer) {
      swatchesContainer.querySelectorAll('input[type="radio"][name*="Colore"]').forEach(input => {
        input.addEventListener("change", () => {
          setTimeout(() => {
            restoreAndShow(productCard, input.value);
          }, 50);
        });
      });

      // Handle initial state
      const initial = swatchesContainer.querySelector('input[type="radio"][name*="Colore"]:checked');
      if (initial) {
        setTimeout(() => {
          restoreAndShow(productCard, initial.value);
        }, 50);
      }
    }
  });

  if (window.jQuery) {
    jQuery(document).ajaxComplete((_, __, settings) => {
      if (settings.url.includes("/products/") && settings.url.endsWith(".js")) {
        document.querySelectorAll('.card-information__group').forEach(productCard => {
          const checked = productCard.querySelector('input[type="radio"][name*="Colore"]:checked');
          if (checked) {
            restoreAndShow(productCard, checked.value);
          }
        });
      }
    });
  }
});